<style>    
    .shopify-collection-card{
/*        padding: 20px;
        text-align: center;
        background: var(--primary);
        margin: 10px 0;
        min-height: 110px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        position: relative;
        overflow: hidden;*/
    }
    .shopify-collection-card > .image-container{
        padding-bottom: 100%;
        margin-bottom: 0px;
        position: relative;
        border-radius: 5px;
        /*background: var(--primary);*/
        background: #383838;
    }
    [data-theme="dark"] .shopify-collection-card > .image-container{
        background: white;
    }
    .shopify-collection-card .collection-title{
        /*font-size: 18px;*/
        /*font-weight: 600;*/
    }
    .shopify-collection-card img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 5px;
        position: absolute;
    }
</style>

<script>

    export default {
        props: ['collection'],
        components: {

        },
        mixins: [],
        data: function () {
            return {

            }
        },
        computed: {
            style: function(){
                var style = {};
                if(this.collection.image_url){
                    
                }
                return style;
            },
            image_url: function(){
                if(this.collection.image_url){
                    return this.collection.image_url;
                }
                if(this.collection.image && this.collection.image.src){
                    return this.collection.image.src;
                }
            }
        },
        created: function () {

        },
        mounted: function () {

        },
        methods: {

        }
    };

</script>

<template>
    <div class="shopify-collection-card" :style="style">
        <div class="image-container">
            <img :src="image_url" v-if="image_url">
        </div>
        <div class="style-body-bold text-center my-2">{{collection.title}}</div>
    </div>
</template>



// WEBPACK FOOTER //
// resources/views/rd/assets/js/v2/components/shopify/shopifyCollectionCard.vue